module.exports = __webpack_public_path__ + "memoire.png?469c02331475ddcee68f90d83dc7a967";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/memoire.png
// module id = 53
// module chunks = 0